import { PaymentServiceInterface} from "interfaces/payment-service.ts";
import { CommunicationService } from "services/mms/mock/CommunicationService";
import { BaseMmsMockService } from "services/mms/mock/entities-services/BaseMockService";
import { FetchMockProps } from "types/mms-base";
import {PaymentSchema} from "mock/schemas.ts";

export class MockPaymentService
    extends BaseMmsMockService
    implements PaymentServiceInterface {

    constructor(communicationService: CommunicationService) {
        super(communicationService)
    }


    private mapPayment = (payment: PaymentSchema): PaymentSchema => {
        return {
            id: payment.id,
            name: payment.name,
            type: payment.type,
            payment_data: payment.payment_data,
            entity_id: payment.entity_id
    }}

    useGetSelfPayment = (): FetchApiProps => {
        const datas: FetchMockProps = {
            mockStatus: 200,
            delay: 500,
            controllerFn: ({user}) => {
                const paymentDataFromSelfEntity = this.communicationService.payments
                    .map((p) => ({...p}))
                    .filter((fp) => fp.entity_id === user?.entity_id)

                return {
                    data: paymentDataFromSelfEntity.map(this.mapPayment),
                }            },
        }
        return this.get(datas)
    }
}
